__turbopack_context__.v({
  "bodyWrapper": "Body-module-scss-module__CWb5sq__bodyWrapper",
  "contentContainer": "Body-module-scss-module__CWb5sq__contentContainer",
  "heroAndBannerSection": "Body-module-scss-module__CWb5sq__heroAndBannerSection",
  "layoutWrapper": "Body-module-scss-module__CWb5sq__layoutWrapper",
  "mainContent": "Body-module-scss-module__CWb5sq__mainContent",
});
